import { Component, Input, OnInit, inject } from '@angular/core';
import { Auth } from '@angular/fire/auth';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Navigation } from 'src/app/enums/navigation.enum';
import { Race } from 'src/app/models/race';
import { RaceService } from 'src/app/services/race.service';

@Component({
    selector: 'app-race-create',
    templateUrl: './race-create.component.html',
    styleUrls: ['./race-create.component.scss'],
    standalone: false
})
export class RaceCreateComponent implements OnInit {

  @Input() redirectOnSuccess = true;
  modalId = 'race-create-modal';
  race: Race = new Race();
  public auth = inject(Auth);
  constructor(
    private _router: Router,
    private _raceService: RaceService,
    private _modalService: NgbModal,
  ) { }

  ngOnInit(): void {
  }
  async add() {
    const id = await this._raceService.add(this.race);
    this._modalService.dismissAll();
    if(this.redirectOnSuccess){
      this._router.navigate([Navigation.RaceDetail, id]);
    }
  }
  open(content) {
    this._modalService.open(content, {ariaLabelledBy: this.modalId, centered: true}).result.then((result) => {
      this.race = new Race();
    }, (reason) => {
      this.race = new Race();
    });
  }
}
